import { LoaderComponent } from './loader.component'
import { MainContentLoaderComponent } from './main-content-loader.component'
import { SortLinkComponent } from './sort-link.component'
import { SubMainContentLoaderComponent } from './sub-main-content-loader.component'
import { TabsComponent } from './tabs.component'
import { TabComponent } from './tab.component'
import { DropComponent } from './drop.component'
import { RoleSwitcherComponent } from './role-switcher.component'
import { PaginationPerPageComponent } from './pagination-per-page.component'
import { ReadMoreComponent } from './read-more.component'
import { ShowPersonalData } from './show-personal-data.component'

export { LoaderComponent }
export { MainContentLoaderComponent }
export { SortLinkComponent }
export { SubMainContentLoaderComponent }
export { TabsComponent }
export { TabComponent }
export { RoleSwitcherComponent }
export { PaginationPerPageComponent }
export { ReadMoreComponent }
export { ShowPersonalData }

export const COMMON_COMPONENTS = [
  LoaderComponent,
  MainContentLoaderComponent,
  SortLinkComponent,
  SubMainContentLoaderComponent,
  TabsComponent,
  TabComponent,
  DropComponent,
  RoleSwitcherComponent,
  PaginationPerPageComponent,
  ReadMoreComponent,
  ShowPersonalData
]



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/components/index.ts